import {ModuleConfiguration} from "../router/model/UserPermission";
import {WebSocketProviderModuleName} from "../utils/names/optionalModuleNames";
import {AngularJsMaterialModuleName} from "../utils/names/requiredModulesNames";

export const WebsocketProviderModuleConfiguration = new ModuleConfiguration(WebSocketProviderModuleName, [
    AngularJsMaterialModuleName
]);